import CinemaProfileImageRound from '@/components/CinemaProfileImageRound';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';
import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { cn } from '@cineamo/ui/src/helpers/cn';

type ShowingCinemasStackedLogosProps = {
    showings: ShowingDto[];
};

// todo: Great example where a test makes sense!

export function ShowingCinemasStackedLogos(props: ShowingCinemasStackedLogosProps) {
    const showingCinemas: CinemaDto[] = props.showings
        .map((showing) => showing._embedded?.cinema)
        .filter((cinema): cinema is CinemaDto => !!cinema);

    const uniqueShowingCinemaIds = new Set(showingCinemas.map((cinema) => cinema.id));
    const uniqueShowingCinemas: CinemaDto[] = Array.from(uniqueShowingCinemaIds)
        .map((cinemaId) => showingCinemas.find((cinema) => cinema.id === cinemaId))
        .filter((cinema): cinema is CinemaDto => !!cinema);

    let componentWidth: string;
    switch (uniqueShowingCinemas.length) {
        case 1:
            componentWidth = 'w-32';
            break;
        case 2:
            componentWidth = 'w-48';
            break;
        default:
            componentWidth = 'w-64';
            break;
    }

    return (
        <div className={cn('relative', componentWidth)}>
            {uniqueShowingCinemas?.slice(0, 2).map((cinema: CinemaDto, index: number) =>
                index === 2 ? (
                    <div
                        key={index}
                        className={cn(
                            'absolute left-32',
                            'h-32 w-32',
                            'rounded-full flex justify-center items-center transition ease-in duration-300',
                            'bg-darkBlue/50 backdrop-blur-md'
                        )}>
                        <div className={cn('rounded-full flex justify-center items-center')}>
                            <span className={cn('text-white')}>{`+${props.showings?.length - 2}`}</span>
                        </div>
                    </div>
                ) : (
                    <div
                        key={index}
                        className={cn('top-0', { 'left-0': index === 0, 'absolute left-16': index === 1 })}>
                        <CinemaProfileImageRound
                            size={'32'}
                            cinema={cinema}
                            key={index}
                        />
                    </div>
                )
            )}
        </div>
    );
}
